import React from "react";
import './warehousenewassortmentcreation.css';
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import {
  TextField,
  Button,
  Typography,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  MenuItem,
  Paper,
  Divider,
  Chip,
  Avatar,
  Alert,
  List,
  ListItem,
  ListItemText,
  Snackbar,
  InputAdornment,
  CircularProgress
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import MuiAlert from '@mui/material/Alert';
import removeIcon from "../../../../assests/awaitingIcon.svg"
import SearchIcon from '@mui/icons-material/Search';

const CohortAssortmentCloneComponent = ({
  startDate,
  setStartDate,
  mvIdInput,
  handleMvIdInputChange,
  selectedMvIds,
  handleAddMvId,
  handleDeleteMvId,
  filteredMvList,
  showMvIdDropdown,
  setShowMvIdDropdown,
  handleCreateNewAssortment,
  openUploadModal,
  handleOpenUploadModal,
  handleCloseUploadModal,
  mvIdsInput,
  setMvIdsInput,
  isVerified,
  handleCheckMvIds,
  handleContinue,
  activeTab,
  setActiveTab,
  categories,
  handleBulkMvIdsPaste,
  handleResetVerification,
  verifiedMvIds = [],
  invalidMvIds = [],
  handleRemoveInvalidMvId,
  duplicateMvIds = [],
  alreadySelectedMvIds = [],
  assortmentDetails,
  ruleFailures,
  failureModalOpen,
  setFailureModalOpen,
  successModalOpen,
  setSuccessModalOpen,
  newAssortmentId,
  setVerifiedMvIds,
  searchLoading // ✅ New prop added
}) => {
  const navigate = useNavigate();
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = React.useState(false);
  const [itemToDelete, setItemToDelete] = React.useState(null);

  return (
    <div className="new-assortment-creation-container">
      <Sidebar />

      <div className="new-assortment-content-wrapper">
        <div className="new-assortment-header-section">
          <div>
            <button
              className="new-assortment-back-button"
              onClick={() => navigate(-1)}
            >
              ←
            </button>
            <h1 className="new-assortment-main-title">Create A Clone cohort Assortment</h1>
          </div>
          <div>
            <Button
              variant="contained"
              className="new-assortment-bulk-upload-button"
              onClick={handleOpenUploadModal}
              startIcon={<CloudUploadIcon />}
            >
              Bulk Upload
            </Button>
          </div>
        </div>

        <div className="new-assortment-main-content-container">
          <div className="new-assortment-split-container">
            <div className="new-assortment-form-section">
              <section className="new-assortment-date-section">
                <Typography variant="h6" className="new-assortment-section-title">
                  Select Start Date
                </Typography>
                <div className="new-assortment-date-input-wrapper">
                  <TextField
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    className="new-assortment-date-picker"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      min: new Date(new Date().setDate(new Date().getDate() + 1))
                        .toISOString()
                        .split('T')[0]
                    }}
                    fullWidth
                    variant="outlined"
                    size="small"
                  />
                </div>
              </section>

              <section className="new-assortment-addmvid-section">
                <Typography variant="h6" className="new-assortment-section-title">
                  Add MV ID
                </Typography>
                <div className="new-assortment-input-container">
                  <div className="new-assortment-search-wrapper" style={{ position: 'relative' }}>
                    <TextField
                      value={mvIdInput}
                      onChange={handleMvIdInputChange}
                      className="new-assortment-mvid-input"
                      fullWidth
                      variant="outlined" // ✅ Changed from standard to outlined
                      size="small"
                      placeholder="Search by MVId or Name..."
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon fontSize="small" />
                          </InputAdornment>
                        ),
                        endAdornment: searchLoading && (
                          <InputAdornment position="end">
                            <CircularProgress size={20} />
                          </InputAdornment>
                        )
                      }}
                    />
                    {showMvIdDropdown && filteredMvList.length > 0 && (
                      <Paper className="new-assortment-dropdown" style={{
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        right: 0,
                        zIndex: 1000,
                        maxHeight: '300px',
                        overflowY: 'auto',
                        marginTop: '4px'
                      }}>
                        {filteredMvList.map((mv) => (
                          <MenuItem
                            key={mv.variant_id}
                            onClick={() => handleAddMvId(mv)}
                            className="new-assortment-dropdown-item"
                          >
                            <div className="mv-item-container" style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              width: '100%',
                              padding: '8px 0'
                            }}>
                              <Box>
                                <Typography variant="body1" style={{ fontWeight: 'bold' }}>
                                  MVID: {mv.id}
                                </Typography>
                                {mv.variant_name && (
                                  <Typography variant="body2" style={{ color: '#666', fontSize: '12px', marginTop: '4px' }}>
                                    {mv.variant_name}
                                  </Typography>
                                )}
                                {mv.mrp && (
                                  <Typography variant="body2" style={{ color: '#888', fontSize: '12px' }}>
                                    ₹{mv.mrp}
                                  </Typography>
                                )}
                              </Box>
                              <Button
                                variant="contained"
                                size="small"
                                className="mv-add-button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleAddMvId(mv);
                                }}
                                style={{
                                  backgroundColor: '#FF8B36',
                                  '&:hover': { backgroundColor: '#FF6B00' }
                                }}
                              >
                                Add
                              </Button>
                            </div>
                          </MenuItem>
                        ))}
                      </Paper>
                    )}
                    {showMvIdDropdown && filteredMvList.length === 0 && !searchLoading && (
                      <Paper className="new-assortment-dropdown" style={{
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        right: 0,
                        zIndex: 1000,
                        padding: '16px',
                        textAlign: 'center'
                      }}>
                        <Typography variant="body2" color="textSecondary">
                          {mvIdInput ? "No results found" : "Start typing to search"}
                        </Typography>
                      </Paper>
                    )}
                  </div>
                </div>
              </section>
            </div>

            <div style={{ width: "400px" }}>
              <div className="toggle-button-container">
                <button
                  className={`toggle-option ${activeTab === 'list' ? 'active' : ''}`}
                  onClick={() => setActiveTab('list')}
                >
                  List
                </button>
                <button
                  className={`toggle-option ${activeTab === 'categories' ? 'active' : ''}`}
                  onClick={() => setActiveTab('categories')}
                >
                  Categories
                </button>
              </div>
              <div className="new-assortment-selected-section">
                <div className="new-assortment-selected-header">
                  <Typography variant="h6" className="new-assortment-section-title">
                    Selected MVID's <br />
                    <span style={{ fontSize: "14px", fontWeight: 400, margin: "0px" }}>
                      From Assortment Id: {assortmentDetails && assortmentDetails.id}
                    </span>
                  </Typography>

                  <div className="new-assortment-cart-indicator">
                    <ShoppingCartIcon />
                    <span className="new-assortment-cart-count">
                      {selectedMvIds.length}
                    </span>
                  </div>
                </div>

                <div className="new-assortment-selected-mvids">
                  {selectedMvIds.length > 0 ? (
                    activeTab === 'list' ? (
                      <div className="new-assortment-mvid-list-container">
                        {selectedMvIds.map((mv, index) => (
                          <div
                            key={`${mv.id}-${index}`}
                            className="selected-mv-item"
                            style={{ position: 'relative' }}
                          >
                            <div
                              style={{
                                position: 'absolute',
                                left: '-30px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                minWidth: '24px',
                                fontWeight: '500',
                                color: '#333',
                                fontSize: '14px',
                                textAlign: 'right',
                                color: "#14AE78",
                                border: "1px solid  #14AE78",
                                borderRadius: "50%",
                                textAlign: "center"
                              }}
                            >
                              {index + 1 < 10 ? `0${index + 1}` : index + 1}
                            </div>

                            <div style={{ display: "flex", alignItems: "flex-start", gap: "8px" }}>
                              {mv.image_id && (
                                <img
                                  alt="Product"
                                  src={`https://s3.ap-south-1.amazonaws.com/daalchini/dcprod/${mv.image_id}`}
                                  style={{
                                    height: "56px",
                                    width: "57px",
                                    borderRadius: "4px",
                                    objectFit: "cover"
                                  }}
                                />
                              )}
                              <div className="mv-item-info">
                                <Typography variant="body1" className="mv-item-name">
                                  <span>{mv.variant_name}</span>
                                </Typography>
                                <Typography variant="body1" className="mv-item-id">
                                  <span>MVID: {mv.id}</span>
                                </Typography>
                                <Typography variant="body2" className="mv-item-price">
                                  ₹ {mv.mrp || '0'}
                                </Typography>
                              </div>
                            </div>
                            <IconButton
                              size="small"
                              className="mv-delete-button"
                              onClick={(e) => {
                                e.stopPropagation();
                                setItemToDelete(mv);
                                setDeleteConfirmationOpen(true);
                              }}
                            >
                              <CloseIcon fontSize="small" />
                            </IconButton>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="category-list-container">
                        {categories.length > 0 ? (
                          categories.map((category, index) => (
                            <div key={index} style={{ marginBottom: '16px', padding: '8px', borderBottom: '1px solid #eee' }}>
                              <Typography variant="subtitle1" className="category-name" style={{ fontWeight: 'bold' }}>
                                {category.name} ({category.count})
                              </Typography>
                            </div>
                          ))
                        ) : (
                          <Typography variant="body2" className="no-categories-message" style={{ padding: '16px', textAlign: 'center' }}>
                            No categories available
                          </Typography>
                        )}
                      </div>
                    )
                  ) : (
                    <Typography variant="body2" className="new-assortment-no-items">
                      No Items Selected Yet
                    </Typography>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="new-assortment-action-buttons-container">
            <Button
              variant="outlined"
              className="new-assortment-cancel-button"
              onClick={() => navigate(-1)}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              className="new-assortment-create-button"
              disabled={!startDate || selectedMvIds.length === 0}
              onClick={handleCreateNewAssortment}
            >
              Save
            </Button>
          </div>
        </div>
      </div>


      <Dialog
        open={openUploadModal}
        onClose={handleCloseUploadModal}
        maxWidth="sm"
        fullWidth
        className="new-assortment-upload-modal"
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Paste or Enter MV IDs</Typography>
            <IconButton onClick={handleCloseUploadModal}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            Paste MV IDs separated by comma
          </Typography>

          {!isVerified ? (
            <>
              <TextField
                fullWidth
                multiline
                rows={4}
                variant="outlined"
                placeholder="Enter MV IDs separated by commas..."
                value={mvIdsInput}
                onChange={(e) => {
                  const input = e.target.value.replace(/[^0-9,]/g, '');
                  const cleanedInput = input.split(',')
                    .map(id => id.replace(/^0+/, ''))
                    .join(',');
                  setMvIdsInput(cleanedInput);
                }}
                onPaste={handleBulkMvIdsPaste}
                className="mv-ids-textarea"
              />

              <Box mt={2} display="flex" justifyContent="flex-end">
                <Button
                  variant="contained"
                  color="success"
                  onClick={handleCheckMvIds}
                  disabled={!mvIdsInput.trim()}
                  className="check-verify-buttonclonecohort"
                  sx={{
                    '&:disabled': {
                      backgroundColor: '#ccc',
                      color: '#111',
                      cursor: 'not-allowed'
                    }
                  }}
                >
                  Verify MV IDs
                </Button>
              </Box>
            </>
          ) : (
            <Box mt={2}>
              {verifiedMvIds.length > 0 && (
                <Box
                  sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 1,
                    p: 1,
                    borderRadius: 1,
                    border: "1px solid #14AE78",
                    mb: 2
                  }}
                >
                  <Typography variant="body2" color="success.main" sx={{ width: '100%' }}>
                    Valid MV IDs ({verifiedMvIds.length})
                  </Typography>
                  {verifiedMvIds.map((mv, index) => (
                    <Chip
                      key={`valid-${index}`}
                      label={mv.id}
                      sx={{
                        backgroundColor: "#14AE7833",
                        borderRadius: 1,
                        border: "1px solid #14AE78",
                        '& .MuiChip-deleteIcon': {
                          color: "#14AE78"
                        }
                      }}
                      onDelete={() => {
                        // Remove this MV ID from verified list
                        const updatedVerified = verifiedMvIds.filter(v => v.id !== mv.id);
                        setVerifiedMvIds(updatedVerified);
                        setMvIdsInput(mvIdsInput.split(',')
                          .filter(id => id !== mv.id.toString())
                          .join(',')
                        );
                      }}
                      deleteIcon={<CloseIcon fontSize="small" />}
                    />
                  ))}
                </Box>
              )}

              {invalidMvIds.length > 0 && (
                <Box
                  sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 1,
                    p: 1,
                    borderRadius: 1,
                    border: "1px solid #DB0F0F",
                    mb: 2
                  }}
                >
                  <Typography variant="body2" color="error" sx={{ width: '100%' }}>
                    Invalid MV IDs ({invalidMvIds.length})
                  </Typography>
                  {invalidMvIds.map((mvId, index) => {
                    const isDuplicate = duplicateMvIds.includes(mvId);
                    const isAlreadySelected = alreadySelectedMvIds.includes(mvId);

                    return (
                      <Chip
                        key={`invalid-${index}`}
                        label={mvId}
                        sx={{
                          backgroundColor: isDuplicate ? "#FF980026" :
                            isAlreadySelected ? "#FFC10726" : "#DB0F0F26",
                          borderRadius: 1,
                          border: isDuplicate ? "1px solid #FF9800" :
                            isAlreadySelected ? "1px solid #FFC107" : "1px solid #DB0F0F"
                        }}
                        onDelete={() => handleRemoveInvalidMvId(mvId)}
                        deleteIcon={<CloseIcon fontSize="small" />}
                      />
                    );
                  })}
                </Box>
              )}

              <Box mt={2} display="flex" justifyContent="flex-end" gap={2}>
                <Button
                  variant="outlined"
                  onClick={handleResetVerification}
                  className="cancel-button"
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="success"
                  onClick={handleContinue}
                  disabled={invalidMvIds.length > 0 || verifiedMvIds.length === 0}
                  sx={{
                    '&.disabled-button': {
                      backgroundColor: '#f5f5f5',
                      color: '#bdbdbd',
                      cursor: 'not-allowed',
                      boxShadow: 'none',
                      '&:hover': {
                        backgroundColor: '#f5f5f5'
                      }
                    }
                  }}
                >
                  Continue
                </Button>
              </Box>
            </Box>
          )}
        </DialogContent>
      </Dialog>

      <Dialog
        open={deleteConfirmationOpen}
        onClose={() => setDeleteConfirmationOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogContent>
          <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" textAlign="center">
            <img src={removeIcon} alt="Remove Icon" style={{ width: "50px", marginBottom: "16px" }} />
            <Typography variant="body1" gutterBottom color="#E02D3C">
              Are you sure you want to remove this item?
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: 2, justifyContent: "space-evenly" }}>
          <Button onClick={() => setDeleteConfirmationOpen(false)} color="primary" variant="outlined">
            No
          </Button>
          <Button
            onClick={() => {
              handleDeleteMvId(itemToDelete);
              setDeleteConfirmationOpen(false);
            }}
            style={{ backgroundColor: "#14AE78" }}
            variant="contained"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={failureModalOpen}
        onClose={() => setFailureModalOpen(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6" style={{ color: "#f44336" }}>
              Rule Validation Failed
            </Typography>
            <IconButton onClick={() => setFailureModalOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Box display="flex" flexDirection="column" gap={2}>
            <Alert severity="error" icon={<ErrorIcon fontSize="large" />}>
              <Typography variant="h6">
                The assortment could not be created due to validation failures
              </Typography>
            </Alert>

            <List dense>
              {ruleFailures && ruleFailures.length > 0 ? (
                ruleFailures.map((failure, index) => (
                  <React.Fragment key={index}>
                    <ListItem>
                      <ListItemText
                        primary={
                          <Typography variant="body1" color="error">
                            {failure.failureType || "Validation Error"}
                          </Typography>
                        }
                        secondary={
                          <Box component="span">
                            {failure.failedItems?.ids && (
                              <Typography variant="body2">
                                MV IDs: {failure.failedItems.ids.join(', ')}
                              </Typography>
                            )}
                          </Box>
                        }
                      />
                    </ListItem>
                    {index < ruleFailures.length - 1 && <Divider />}
                  </React.Fragment>
                ))
              ) : (
                <Typography variant="body2" className="no-failures-message">
                  No specific failure details available
                </Typography>
              )}
            </List>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setFailureModalOpen(false)}
            color="primary"
            variant="outlined"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Success Modal */}
      <Dialog
        open={successModalOpen}
        onClose={() => {
          setSuccessModalOpen(false);
          navigate(-1);
        }}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6" style={{ color: "#4caf50" }}>
              Assortment Created Successfully
            </Typography>
            <IconButton onClick={() => {
              setSuccessModalOpen(false);
              navigate(-1);
            }}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Box display="flex" flexDirection="column" alignItems="center" gap={2} p={2}>
            <CheckCircleIcon style={{ fontSize: 60, color: "#4caf50" }} />
            <Typography variant="h5" align="center">
              New Assortment Created
            </Typography>
            <Typography variant="body1" align="center">
              Assortment ID: <strong>{newAssortmentId}</strong>
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setSuccessModalOpen(false);
              navigate(-1);
            }}
            color="primary"
            variant="contained"
            fullWidth
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* REMOVED: Max Items Modal - No longer needed */}

      {/* Rule Failure Modal */}
      <Dialog
        open={failureModalOpen}
        onClose={() => setFailureModalOpen(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6" style={{ color: "#f44336" }}>
              Rule Validation Failed
            </Typography>
            <IconButton onClick={() => setFailureModalOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Box display="flex" flexDirection="column" gap={2}>
            <Alert severity="error" icon={<ErrorIcon fontSize="large" />}>
              <Typography variant="h6">
                The assortment could not be created due to validation failures
              </Typography>
            </Alert>

            {ruleFailures.length > 0 ? (
              <List dense>
                {ruleFailures.map((failure, index) => (
                  <React.Fragment key={index}>
                    <ListItem>
                      <ListItemText
                        primary={
                          <Typography variant="body1" color="error">
                            {failure.failureType ?
                              failure.failureType.replace(/_/g, ' ') :
                              'Validation Error'}
                          </Typography>
                        }
                        secondary={
                          <Box component="span">
                            {failure.failedItems && failure.failedItems.ids && (
                              <Typography variant="body2">
                                MV IDs: {Array.isArray(failure.failedItems.ids) ?
                                  failure.failedItems.ids.join(', ') :
                                  String(failure.failedItems.ids)}
                              </Typography>
                            )}
                          </Box>
                        }
                      />
                    </ListItem>
                    {index < ruleFailures.length - 1 && <Divider />}
                  </React.Fragment>
                ))}
              </List>
            ) : (
              <Typography variant="body2" color="textSecondary">
                No specific failure details available
              </Typography>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setFailureModalOpen(false)}
            color="primary"
            variant="outlined"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CohortAssortmentCloneComponent;